import React, { ReactNode } from 'react';
import { AlertCircleIcon } from 'lucide-react';
type CheckboxFieldProps = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
  children: ReactNode;
};
export function CheckboxField({
  id,
  checked,
  onChange,
  error,
  children
}: CheckboxFieldProps) {
  return <div data-id="element-38" data-mp="ugm3xh32qajh">
      <div className="flex items-start gap-3" data-id="element-39" data-mp="ug2hpo6e4zzn">
        <input id={id} name={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} aria-required="true" aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} className={`mt-0.5 h-5 w-5 shrink-0 cursor-pointer rounded-sm border accent-navy ${error ? 'border-danger' : 'border-navy/30'}`} data-id="element-40" data-mp="18h6k05hlts9a" />
        <label htmlFor={id} className="cursor-pointer text-sm leading-relaxed text-ink" data-id="element-41" data-mp="1s3b9g0wzj5a3">
          {children}
        </label>
      </div>
      {error && <p id={`${id}-error`} className="ml-8 mt-2 flex items-start gap-1.5 text-[13px] text-danger" data-id="element-42" data-mp="1gp33e30yxm7n">
          <AlertCircleIcon className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-43" data-mp="1lofsyvj857dx" />
          {error}
        </p>}
    </div>;
}